<template>
	<div class="page" style="position: relative;overflow-y: auto;">
		<div class="titleView">
			<el-row>
				<el-col :span="5">
					<div style="font-size: 16px;font-weight: bold;padding:0 10px;">员工资产信息</div>
				</el-col>
				<el-col :span="4" :offset="15">
					<el-button type="warning" @click="back" size="small">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="titleView">
			<el-row>
				<el-col :span="5">
					<div style="font-size: 16px;padding:0 10px;">门店:{{shopInfo.name}}</div>
				</el-col>
				<el-col :span="4" :offset="1">
					<div style="font-size: 16px;padding:0 10px;">员工名字:{{staffInfo.name}}</div>
				</el-col>
			</el-row>
		</div>
		<div class="shopClass">
			<el-table :data="assetsList" tooltip-effect="dark" size="small">
				<el-table-column label="编号">
					<template slot-scope="scope">
						{{scope.row.assetsCode}}
					</template>
				</el-table-column>
				<el-table-column label="名称">
					<template slot-scope="scope">
						{{scope.row.assetsName}}
					</template>
				</el-table-column>
				<el-table-column label="规格">
					<template slot-scope="scope">
						{{scope.row.skuName}}
					</template>
				</el-table-column>
				<el-table-column label="所在位置">
					<template slot-scope="scope">
						{{scope.row.position}}
					</template>
				</el-table-column>
				<el-table-column prop="stockInfo" label="负责数量" align="center">
					<template slot-scope="scope">
						{{$public.jia(scope.row.stockInfo.reality,scope.row.stockInfo.lock)}}
					</template>
				</el-table-column>
				<el-table-column label="锁定数量" align="center">
					<template slot-scope="scope">
						{{scope.row.stockInfo.lock}}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click='assetsInfo(scope.row)'>查询</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-drawer title="员工资产查询" :visible.sync="drawer" >
			<div style="padding: 5px;">
				<div style="font-size: 16px;font-weight:600;padding:0 10px;">员工资产查询</div>
				<div style="display: flex;justify-content: space-between;margin: 20px;">
					<span>编号:{{info?info.assetsCode:''}}</span>
					<span>名称:{{info?info.assetsName:''}}</span>
					
				</div>
				<div style="display: flex;justify-content: space-between;margin: 20px;">
					<span>规格:{{info?info.skuName:''}}</span>
					<span>负责数量:{{info?info.stockInfo.reality:''}}</span>
					
				</div>
				<div style="display: flex;justify-content: space-between;margin: 20px;">
					<span>锁定数量:{{info?info.stockInfo.lock:''}}</span>
				</div>
				<div v-show="info?info.stockInfo.lock:''">
					<div style="font-size: 16px;font-weight:600;padding:0 10px;margin: 20px;">锁定信息</div>
					<div style="font-size: 13px;border: 1px solid;margin: 5px;padding: 8px;" v-for="(item,index) in lockList" :key="index">
						<div style="display: flex;justify-content: space-between;margin:10px;">
							<span>申请时间:{{item.createOperationInfo
.operationTime}}</span><span style="color: orange;cursor: pointer;">{{item.processType.name}}</span>
						</div>
						<div style="margin: 10px;">交接人:{{item.receiveInfo.name||''}}</div>
						<div style="margin: 10px;">交接数量:{{item.assetsInfo.length}}</div>
					</div>
					<!-- <div style="font-size: 13px;border: 1px solid;margin: 5px;padding: 8px;">
						<div style="display: flex;justify-content: space-between;margin:10px;">
							<span>申请时间:</span><span style="color: orange;">报废</span>
						</div>
						<div style="margin: 10px;">报废数量:</div>
					</div> -->
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false,
				fixedHeight: 0,
				assetsList: [],
				info: null,
				shopInfo: null,
				staffInfo: null,
				lockList: []
			}
		},
		mounted() {
			this.getInfo();
		},
		methods: {
			// 交接
			// handover(item){
			// 	console.log(item)
			// 	let params = {
			// 		'shopInfo':item.shopInfo,
			// 		'receiveInfo':item.receiveInfo,
			// 		'remark':item.remark,
			// 		'assetsList':item.assetsList,
			// 		'applyInfo':item.applyInfo,
			// 	};
			// 	this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsStaff/handover', params).then(res => {
			// 		console.log(res)
			// 		// loading.close()
			// 		// if (res.code == 0) {
			// 		// }
			// 	})
			// },
			// 返回
			back() {
				this.$router.go(-1)
			},
			//获取详细信息
			getInfo() {
				let loading = this.$loading();
				let params = {
					'staffId': this.$route.query.staffId,
					'shopId': this.$route.query.shopId,
				};
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsStaff/listForStaff', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.assetsList = res.data;
						this.shopInfo = res.data[0].shopInfo,
							this.staffInfo = res.data[0].staffInfo,
							console.log('员工资产详情', this.assetsList)
					}
				})
			},

			// 资产查询
			assetsInfo(row) {
				this.drawer = true;
				let loading = this.$loading();
				let params = {
					'id': row.id,
				};
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsStaff/detail', params).then(res => {
					loading.close()
					if (res.code == 0) {
						console.log(res)
						this.info = res.data;
						if (res.data.stockInfo.lock) {
							this.getLock(res.data);
						}

						// console.log('员工资产详情', this.assetsList)
					}
				})
			},
			// 获取锁定数据
			getLock(row) {
				this.drawer = true;
				let loading = this.$loading();
				let params = {
					'staffId': row.staffInfo.id,
					'assetsCode': row.assetsCode,
				};
				this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsHandover/assetsList', params).then(res => {
					loading.close()
					console.log('锁定详情', res)
					if (res.code == 0) {
						// console.log(res)
						this.lockList = res.data;
					}
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	.page {
		height: 100%;

		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
	}

	::v-deep element.style {
		width: 800px !important;
	}
</style>
